<template>
  <div class="contactus">
    <div class="contact-us w1200">
      <h2 class="contact-us-title"><span>联系我们:</span></h2>
      <p class="sever-time">客服工作时间：09:00-22:00</p>
      <p class="sever-time">非工作时间我们不能及时回复您消息，请在站内信中留下问题，或者留下您的联系方式，我们会及时与您联系</p>
      <div class="contact-way">
        <ul class="tabs-list">
          <li class="tabs-item">
            <i class="icon icon1"></i>
            <span>{{aboutInfo.tel}}</span>
          </li>
          <li class="tabs-item">
            <i class="icon icon2"></i>
            <span>{{aboutInfo.address}}</span>
          </li>
          <li class="tabs-item">
            <i class="icon icon3"></i>
            <span>{{aboutInfo.email}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      aboutInfo: {}
    }
  },
  methods: {
  },
  mounted () {

  },
  created () {
    this.aboutInfo = JSON.parse(localStorage.getItem('aboutInfo'))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .contactus{
    width: 100%;
    background: #e7e7e7;
  }
  .contact-us{
    padding:15px 0px;
    text-align: center;
  }
  .contact-us .contact-us-title{
    padding: 25px 0px;
  }
  .contact-us .contact-us-title span{
    font-size: 30px;
    color: #000;
    background: url("../../../../static/images/bottom_01.png") 0px center no-repeat;
    background-size: 38px 34px;
    padding-left: 50px;
  }
  .contact-us .sever-time{
    font-size: 12px;
    color:#000;
    line-height: 22px;
  }
  .contact-way .tabs-list{
    width: 722px;
    overflow: hidden;
    margin: 0px auto;
    padding: 50px 0px 34px 0px;
  }
  .contact-way .tabs-list .tabs-item{
    text-align: center;
    width: 33.33%;
    float: left;
  }
  .contact-way .tabs-list .tabs-item .icon{
    width: 38px;
    height: 34px;
    margin: 0px auto;
    display:block;
    background-position: 0px 0px;
    background-repeat: no-repeat;
    background-size: 38px 34px;
  }
  .contact-way .tabs-list .tabs-item span{
    font-size:18px;
    color:#000;
    margin-top: 20px;
    display: inline-block;
  }
  .contact-way .tabs-list .tabs-item .icon1{
    background-image: url(../../../../static/images/bottom_02.png);
  }
  .contact-way .tabs-list .tabs-item .icon2{
    background-image: url(../../../../static/images/bottom_03.png);
  }
  .contact-way .tabs-list .tabs-item .icon3{
    background-image: url(../../../../static/images/bottom_04.png);
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ContactUs/ContactUs.vue